// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__NZo4D","quoteTitle":"Quote_quoteTitle__Dog_v","quoteText":"Quote_quoteText__bct6U"};